import React, { useState, useEffect } from 'react';
import {
    Container,
    Typography,
    Paper,
    TextField,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Button,
    Box,
    CircularProgress,
    IconButton,
    Autocomplete,
    Alert,
    Snackbar,
    FormHelperText
} from '@mui/material';
import {
    CloudUpload as CloudUploadIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';

const CrearCargaTgu = () => {
    const [tipos, setTipos] = useState([]);
    const [tipoSeleccionado, setTipoSeleccionado] = useState('');
    const [campos, setCampos] = useState([]);
    const [valoresFormulario, setValoresFormulario] = useState({
        fecha_creacion: '',
    });
    const [procuradores, setProcuradores] = useState([]);
    const [tiposComite, setTiposComite] = useState([]);
    const [areas, setAreas] = useState([]);
    const [loading, setLoading] = useState({ enviando: false });
    const [error, setError] = useState(null);
    const [attachmentMetadata, setAttachmentMetadata] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(null);
    const [currentUser] = useState({ id: 1 });
    const [participantes, setParticipantes] = useState([]);
    const [loadingParticipantes, setLoadingParticipantes] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [openErrorAlert, setOpenErrorAlert] = useState(false);


    const [formErrors, setFormErrors] = useState({});


    const validacionesPorTipo = {
        1: {
            "tipo_de_comite": { requerido: true },
            "fecha_comite": { requerido: true },
            "procurador": { requerido: true }
        },
        2: {
            "nombre_del_notario": { requerido: true },
            "fecha_asignacion": { requerido: true },
            "nombre_del_participante": { requerido: true },
            "procurador": { requerido: true }
        },
        3: {
             "memorando": { requerido: true },
            "fecha_asignacion": { requerido: true },
            "nombre_del_participante": { requerido: true },
            "area": { requerido: true },
            "procurador": { requerido: true }
        },
        4: {
            "memorando": { requerido: true },
            "fecha_asignacion": { requerido: true },
            "nombre_del_participante": { requerido: true },
            "area": { requerido: true },
            "procurador": { requerido: true }
        },
        5: {
          "nombre_del_notario": { requerido: true },
            "fecha_asignacion": { requerido: true },
            "nombre_del_participante": { requerido: true },
            "procurador": { requerido: true }
        },
        6: {
            "memorando": { requerido: true },
            "nombre_del_participante": { requerido: true },
            "area": { requerido: true },
            "procurador": { requerido: true }
        }
    }

    // Obtener tipos al iniciar
    useEffect(() => {
        const fetchTipos = async () => {
            try {
                const response = await fetch('https://bei360.injupemp.gob.hn:8444/api/tramites-administrativos/tipos/?sucursal_id=1');
                const data = await response.json();
                setTipos(data);
            } catch (err) {
                setError('Error al cargar tipos de trámite');
            }
        };
        fetchTipos();
    }, []);

    // Obtener procuradores al iniciar
    useEffect(() => {
        const fetchProcuradores = async () => {
            try {
                const response = await fetch('https://bei360.injupemp.gob.hn:8444/api/auth/oficialesLegal/');
                const data = await response.json();
                setProcuradores(data);
            } catch (err) {
                console.error(err);
                setError('Error al cargar procuradores');
            }
        };
        fetchProcuradores();
    }, []);

    // Obtener Tipos de comite
    useEffect(() => {
        const fetchTiposComite = async () => {
            try {
                const response = await fetch('https://bei360.injupemp.gob.hn:8444/api/tramites-administrativos/comites/');
                const data = await response.json();
                setTiposComite(data);
            } catch (err) {
                console.error(err);
                setError('Error al cargar tipos de comité');
            }
        };
        fetchTiposComite();
    }, []);

    // Obtener áreas al iniciar
    useEffect(() => {
        const fetchAreas = async () => {
            try {
                const response = await fetch('https://bei360.injupemp.gob.hn:8444/api/tramites-administrativos/areas/');
                if (!response.ok) throw new Error('Error en la respuesta');
                const data = await response.json();
                setAreas(data);
                console.log('Áreas cargadas:', data); // Verificación en consola
            } catch (err) {
                console.error('Error al cargar áreas:', err);
                setError('Error al cargar las áreas disponibles');
            }
        };
        fetchAreas();
    }, []);

    // Obtener campos dinámicos al seleccionar tipo
    useEffect(() => {
        if (tipoSeleccionado) {
            const fetchCampos = async () => {
                try {
                    const response = await fetch(`https://bei360.injupemp.gob.hn:8444/api/tramites-administrativos/campos/${tipoSeleccionado}/`);
                    const data = await response.json();
                    setCampos(data.campos || []);
                } catch (err) {
                    setError('Error al cargar campos dinámicos');
                }
            };
            fetchCampos();
        }
    }, [tipoSeleccionado]);

    // Buscar demandantes con debounce
    useEffect(() => {
        const timerId = setTimeout(() => {
            if (searchTerm.trim() !== '') {
                fetchParticipantes(searchTerm);
            }
        }, 500);

        return () => clearTimeout(timerId);
    }, [searchTerm]);

    const fetchParticipantes = async (term = '') => {
        setLoadingParticipantes(true);
        try {
            const response = await fetch(`https://bei360.injupemp.gob.hn:8444/api/partes/listar/?search=${term}`);
            if (!response.ok) throw new Error('Error al cargar participantes');
            const data = await response.json();
            setParticipantes(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoadingParticipantes(false);
        }
    };

    const handleChange = (e, campo) => {
        setValoresFormulario((prev) => ({
            ...prev,
            [campo]: e.target.value,
        }));
    };

    const handleAutocompleteChange = (event, newValue, campo) => {
        setValoresFormulario((prev) => ({
            ...prev,
            [campo]: typeof newValue === 'string' ? newValue : newValue?.NombreParte || '',
        }));
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const newAttachments = files.map(file => ({
            file,
            name: file.name,
            size: file.size,
            type: file.type
        }));
        setAttachmentMetadata([...attachmentMetadata, ...newAttachments]);
    };

    const uploadAttachment = async (tramiteId) => {
        try {
            if (attachmentMetadata.length === 0) return [];

            setUploadProgress({ total: attachmentMetadata.length, completed: 0 });
            const uploadedFilesList = [];

            for (const attachment of attachmentMetadata) {
                const formData = new FormData();
                formData.append('archivo', attachment.file);
                formData.append('entity_id', tramiteId);
                formData.append('usuario_id', currentUser.id);
                

                const response = await fetch('https://bei360.injupemp.gob.hn:8444/api/tramites-administrativos/adjuntos/subir/', {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'Accept': 'application/json',
                    }
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || "Error al subir el archivo");
                }

                const result = await response.json();
                uploadedFilesList.push(result);
                setUploadProgress(prev => ({ ...prev, completed: prev.completed + 1 }));
            }

            return uploadedFilesList;
        } catch (error) {
            throw new Error("Error al subir archivos: " + error.message);
        } finally {
            setUploadProgress(null);
        }
    };

    const validarFormulario = () => {
        const errores = {};
        const reglasValidacion = validacionesPorTipo[tipoSeleccionado] || {};

        // Mapeo completo desde nombre interno a nombre real en el formulario
        const mapeoCamposFormulario = {
            'fecha_comite': 'FECHA EN QUE SE REUNE EL COMITE',
            'fecha_asignacion': 'FECHA DE ASIGNACION',
            'nombre_del_participante': 'NOMBRE DEL PARTICIPANTE',
            'nombre_del_notario': 'NOMBRE DEL NOTARIO',
            'memorando': 'MEMORANDO',
            'tipo_de_comite': 'TIPO DE COMITE',
            'area': 'AREA',
            'procurador': 'PROCURADOR',
        };

        Object.keys(reglasValidacion).forEach((campo) => {
            const regla = reglasValidacion[campo];
            const nombreFormulario = mapeoCamposFormulario[campo] || campo;
            const valor = valoresFormulario[nombreFormulario];

            if (regla.requerido && (valor === undefined || valor === null || valor === '')) {
                errores[campo] = 'Este campo es requerido';
            }

            if (regla.fechaFutura && valor) {
                const fechaSeleccionada = new Date(valor);
                const hoy = new Date();
                hoy.setHours(0, 0, 0, 0);

                if (fechaSeleccionada <= hoy) {
                    errores[campo] = 'La fecha debe ser futura';
                }
            }
        });

        setFormErrors(errores);
        return Object.keys(errores).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validarFormulario()) {
            setError('Por favor complete todos los campos requeridos correctamente');
            return;
        }

        setLoading({ enviando: true });

        const payload = {
            tipo: parseInt(tipoSeleccionado),
            fecha_creacion: new Date().toISOString(),
            sucursal: 1,
            area: valoresFormulario.area ? [valoresFormulario.area] : null,
            tipo_de_comite: tipoSeleccionado === '1' ? valoresFormulario['TIPO DE COMITE'] : null,
            fecha_comite: null,
            procurador: null,
            estado: 'Abierto',
            nombre_del_notario: null,
            nombre_del_participante: null,
            fecha_asignacion: null,
            memorando: null
        };

        const mapeoCampos = {
            'FECHA EN QUE SE REUNE EL COMITE': 'fecha_comite',
            'FECHA DE ASIGNACION': 'fecha_asignacion'
        };

        campos.forEach((campo) => {
            const payloadField = mapeoCampos[campo] ||
                campo.toLowerCase().replace(/ /g, '_');

            if (valoresFormulario[campo]) {
                payload[payloadField] = valoresFormulario[campo];
            }
        });

        try {
        const response = await fetch('https://bei360.injupemp.gob.hn:8444/api/tramites-administrativos/crear/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        });

        if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.detail || JSON.stringify(errData));
        }

        const result = await response.json();

        // Subida de adjuntos (si falla, mostramos error SIN “pegar” el estado)
        if (attachmentMetadata.length > 0) {
        try {
            await uploadAttachment(result.id);
        } catch (e) {
            setError(`Error al subir archivos: ${e.message || 'desconocido'}`);
            setOpenErrorAlert(true);
        }
        }

        setSuccessMessage('Trámite creado exitosamente');
        setOpenSuccessAlert(true);
        limpiarFormulario();
    } catch (err) {
        console.error('Error:', err);
        setError(`Error al enviar: ${err.message}`);
        setOpenErrorAlert(true);
    } finally {
        setLoading({ enviando: false });
    }
    };

    const handleCloseSuccess = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpenSuccessAlert(false);
        setSuccessMessage('');
        };

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpenErrorAlert(false);
        setError(null);
        };


    const getFieldError = (campoOriginal) => {
        // Mapear nombres de campos del formulario a las claves de validación
        const mapaNombresCampos = {
            'TIPO DE COMITE': 'tipo_de_comite',
            'FECHA EN QUE SE REUNE EL COMITE': 'fecha_comite',
            'FECHA DE ASIGNACION': 'fecha_asignacion',
            'NOMBRE DEL NOTARIO': 'nombre_del_notario',
            'NOMBRE DEL PARTICIPANTE': 'nombre_del_participante',
            'PROCURADOR': 'procurador',
            'MEMORANDO': 'memorando',
            'AREA': 'area',

        };

        const campoUpper = campoOriginal.toUpperCase();
        const campoValidacion = mapaNombresCampos[campoUpper] ||
            campoOriginal.toLowerCase().replace(/ /g, '_');

        return formErrors[campoValidacion];
    };

    useEffect(() => {
        const now = new Date();
        const fechaFormateada = now.toISOString().slice(0, 16).replace('T', ' ');
        setValoresFormulario((prev) => ({
            ...prev,
            fecha_creacion: fechaFormateada,
        }));
    }, []);

    const limpiarFormulario = () => {
        const now = new Date();
        const fechaFormateada = now.toISOString().slice(0, 16).replace('T', ' ');

        setTipoSeleccionado('');
        setCampos([]);
        setAttachmentMetadata([]);
        setSearchTerm('');
        setValoresFormulario({
            fecha_creacion: fechaFormateada,
        });
    };

    const removeAttachment = (index) => {
        const newAttachments = [...attachmentMetadata];
        newAttachments.splice(index, 1);
        setAttachmentMetadata(newAttachments);
    };

    const renderCampo = (campo, idx) => {
        const campoUpper = campo.toUpperCase();
        const isFecha = campoUpper.includes('FECHA DE ASIGNACION') ||
            campoUpper.includes('FECHA EN QUE SE REUNE EL COMITE');

        const error = getFieldError(campo);
        const esRequerido = validacionesPorTipo[tipoSeleccionado]?.[
            campo.toLowerCase().replace(/ /g, '_')
        ]?.requerido;

        // Manejar específicamente el campo "TIPO DE COMITE"
        if (campoUpper === 'TIPO DE COMITE') {
            return (
                <FormControl fullWidth key={idx} sx={{ mt: 2 }} error={!!error} required={esRequerido}>
                    <InputLabel id={`tipo-comite-label-${idx}`}>Tipo de Comité</InputLabel>
                    <Select
                        labelId={`tipo-comite-label-${idx}`}
                        value={valoresFormulario[campo] || ''}
                        onChange={(e) => handleChange(e, campo)}
                        label="Tipo de Comité"
                    >
                        <MenuItem value="">
                            <em>Seleccione un tipo de comité</em>
                        </MenuItem>
                        {tiposComite.map((tipo) => (
                            <MenuItem
                                key={tipo.id}
                                value={tipo.nombre || tipo}
                            >
                                {tipo.nombre || tipo}
                            </MenuItem>
                        ))}
                    </Select>
                    {error && <FormHelperText>{error}</FormHelperText>}
                </FormControl>
            );
        }

        if (campoUpper === 'PROCURADOR') {
            return (
                <FormControl fullWidth key={idx} error={!!error} required={esRequerido}>
                    <InputLabel id={`procurador-label-${idx}`}>{campo}</InputLabel>
                    <Select
                        labelId={`procurador-label-${idx}`}
                        value={valoresFormulario[campo] || ''}
                        onChange={(e) => handleChange(e, campo)}
                        label={campo}
                    >
                        <MenuItem value="">Seleccione un procurador</MenuItem>
                        {procuradores.map((p) => (
                            <MenuItem key={p.id} value={p.nombre}>
                                {p.nombre}
                            </MenuItem>
                        ))}
                    </Select>
                    {error && <FormHelperText>{error}</FormHelperText>}
                </FormControl>
            );
        }

        if (campoUpper === 'AREA' || campoUpper === 'ÁREA') {
            return (
                <FormControl fullWidth key={idx} sx={{ mt: 2 }} error={!!error} required={esRequerido}>
                    <InputLabel id={`area-label-${idx}`}>Área</InputLabel>
                    <Select
                        labelId={`area-label-${idx}`}
                        value={valoresFormulario[campo] || ''}
                        onChange={(e) => handleChange(e, campo)}
                        label="Área"
                    >
                        <MenuItem value="">
                            <em>Seleccione un área</em>
                        </MenuItem>
                        {areas.map((area) => (
                            <MenuItem key={area.id} value={area.id}>
                                {area.nombre}
                            </MenuItem>
                        ))}
                    </Select>
                    {error && <FormHelperText>{error}</FormHelperText>}
                </FormControl>
            );
        }

        if (campoUpper === 'NOMBRE DEL PARTICIPANTE') {
            return (
                <Autocomplete
                    key={idx}
                    freeSolo
                    options={participantes}
                    getOptionLabel={(option) => typeof option === 'string' ? option : option.NombreParte || ''}
                    value={valoresFormulario[campo] || ''}
                    onChange={(event, newValue) => handleAutocompleteChange(event, newValue, campo)}
                    onInputChange={(event, newInputValue) => {
                        setSearchTerm(newInputValue);
                    }}
                    loading={loadingParticipantes}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={campo}
                            variant="outlined"
                            fullWidth
                            error={!!error}
                            helperText={error}
                            required={esRequerido}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {loadingParticipantes ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            }}
                        />
                    )}
                />
            );
        }

        if (isFecha) {
            const campoValidacion = campoUpper === 'FECHA EN QUE SE REUNE EL COMITE' ? 'fecha_comite' : 'fecha_asignacion';
            const error = formErrors[campoValidacion];
            const esRequerido = validacionesPorTipo[tipoSeleccionado]?.[campoValidacion]?.requerido;
            const debeSerFutura = validacionesPorTipo[tipoSeleccionado]?.[campoValidacion]?.fechaFutura;
            return (
                <TextField
                    key={idx}
                    label={campo}
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={valoresFormulario[campo] || ''}
                    onChange={(e) => {
                        handleChange(e, campo);

                        // Validación de fecha futura en tiempo real
                        if (debeSerFutura && e.target.value) {
                            const fechaSeleccionada = new Date(e.target.value);
                            const hoy = new Date();
                            hoy.setHours(0, 0, 0, 0);

                            if (fechaSeleccionada <= hoy) { // Cambiado de > a <=
                                setFormErrors(prev => ({
                                    ...prev,
                                    [campoValidacion]: 'La fecha debe ser futura'
                                }));
                            } else {
                                setFormErrors(prev => {
                                    const nuevosErrores = { ...prev };
                                    delete nuevosErrores[campoValidacion];
                                    return nuevosErrores;
                                });
                            }
                        }
                    }}
                    onBlur={() => {
                        if (esRequerido && !valoresFormulario[campo]) {
                            setFormErrors(prev => ({
                                ...prev,
                                [campoValidacion]: 'Este campo es requerido'
                            }));
                        }
                    }}
                    fullWidth
                    error={!!error}
                    helperText={error}
                    required={esRequerido}
                    inputProps={{
                        min: new Date().toISOString().split('T')[0] // Fecha mínima = hoy
                    }}
                />
            );
        }
        return (
            <TextField
                key={idx}
                label={campo}
                value={valoresFormulario[campo] || ''}
                onChange={(e) => handleChange(e, campo)}
                fullWidth
                error={!!error}
                helperText={error}
                required={esRequerido}
            />
        );
    };

    return (
        <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
            <Paper elevation={3} sx={{ p: 4, backgroundColor: '#F8F8FF' }}>
                <Typography variant="h4" align="center" gutterBottom sx={{ mb: 4 }}>
                    Crear Carga
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <FormControl fullWidth>
                        <InputLabel id="tipo-carga-label">Tipo de Carga:</InputLabel>
                        <Select
                            labelId="tipo-carga-label"
                            value={tipoSeleccionado}
                            onChange={(e) => setTipoSeleccionado(e.target.value)}
                            label="Tipo de Carga:"
                        >
                            <MenuItem value="">Seleccione un tipo</MenuItem>
                            {tipos.map((tipo) => (
                                <MenuItem key={tipo.id} value={tipo.id}>
                                    {tipo.nombre}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {tipoSeleccionado && (
                        <Box
                            component="form"
                            onSubmit={handleSubmit}
                            sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}
                        >
                            {campos.map((campo, idx) => renderCampo(campo, idx))}

                            <Box sx={{ mt: 2 }}>
                                <Typography variant="subtitle1" gutterBottom>
                                    Adjuntos
                                </Typography>
                                <input
                                    type="file"
                                    id="file-upload"
                                    multiple
                                    onChange={handleFileChange}
                                    style={{ display: 'none' }}
                                />
                                <label htmlFor="file-upload">
                                    <Button variant="outlined" component="span" color='success' startIcon={<CloudUploadIcon />}>
                                        Subir Archivos
                                    </Button>
                                </label>

                                {attachmentMetadata.length > 0 && (
                                    <Box sx={{ mt: 2 }}>
                                        <Typography variant="subtitle1">Archivos seleccionados:</Typography>
                                        <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                                            {attachmentMetadata.map((file, index) => (
                                                <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                                    <span style={{ marginRight: '8px' }}>{file.name}</span>
                                                    <IconButton
                                                        size="small"
                                                        color="error"
                                                        onClick={() => removeAttachment(index)}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </li>
                                            ))}
                                        </ul>
                                    </Box>
                                )}

                                {uploadProgress && (
                                    <Box sx={{ mt: 2 }}>
                                        <Typography variant="body2">
                                            Subiendo archivos: {uploadProgress.completed} de {uploadProgress.total}
                                        </Typography>
                                        <CircularProgress
                                            variant="determinate"
                                            value={(uploadProgress.completed / uploadProgress.total) * 100}
                                        />
                                    </Box>
                                )}
                            </Box>

                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                <Button
                                    variant="outlined"
                                    size="large"
                                    onClick={limpiarFormulario}
                                    color="error"
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    size="large"
                                    disabled={loading.enviando}
                                    startIcon={loading.enviando && <CircularProgress size={18} />}
                                    sx={{ backgroundColor: '#19438C', color: 'white' }}
                                >
                                    {loading.enviando ? 'Enviando...' : 'Guardar'}
                                </Button>
                            </Box>
                        </Box>
                    )}
                </Box>
            </Paper>
        <Snackbar
            open={openSuccessAlert}
            autoHideDuration={2000}
            onClose={handleCloseSuccess}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
            <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%' }}>
                {successMessage}
            </Alert>
            </Snackbar>

            <Snackbar
            open={openErrorAlert}
            autoHideDuration={4000}
            onClose={handleCloseError}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
            <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
                {error}
            </Alert>
            </Snackbar>

        </Container>
    );
};

export default CrearCargaTgu;